import axios from "axios";
import { API_ENDPOINTS } from "../API/apiConfig";
import { getTextColour } from "./datagrids/utils";

export const autoFill = (list, items, data) => {
  const cellCount = list.list_details.cols * list.list_details.rows;

  const pages =
    Math.round(items?.length / cellCount) > 0
      ? Math.round(items?.length / cellCount)
      : 1;

  let buttonArr = [];
  for (let index = 1; index <= pages; index++) {
    buttonArr.push({
      page: index,
      min: cellCount * (index - 1) - 1 < 0 ? 0 : cellCount * (index - 1) - 1,
      max: cellCount * index - 1,
    });
  }
  const maxCells = cellCount * pages - 1;
  console.log("items", items);
  list.list_details.pages = pages;

  for (let i = 0; i <= maxCells; i++) {
    const colour1 = data.colours[0].palette_details.colours.find(
      (col) => col.colour === "#000000"
    );
    const colour2 = getTextColour(colour1.colour);
    list.list_details.buttons.push({
      id: i.toString(),
      index: i,
      style: {
        background: colour1.index,
        foreground: colour2.index,
        alignmentV: 1,
        alignmentH: 1,
        font: "10B",
      },
      text: items[i]?.plu_name !== undefined ? items[i].plu_name : "",
      mx: 1,
      my: 1,
      pageNo: 1,
      size: 1,
      functionType: items[i]?.plu_number !== undefined ? 21 : 0,
      functionValue:
        items[i]?.plu_number !== undefined ? parseInt(items[i].plu_number) : 0,
      hideText: 0,
    });
  }

  list.list_details.buttons.map((x, index) => {
    const page = buttonArr?.find(
      (button) => index >= button.min && index <= button.max
    );
    x.pageNo = page?.page;
  });
};

export default function addButtonId(setVariant) {
  console.log("here button id");
  setVariant((draft) => {
    draft?.list_details?.buttons?.map((button, index) => {
      button.id = index.toString();
      button.index = index;
      return button;
    });
  });
}

export const getHistory = async (
  variantInit,
  getAccessTokenSilently,
  setListHistory,
  setVariant,
  setPageArr,
  setItem,
  setIndex
) => {
  const token = await getAccessTokenSilently();

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  axios
    .get(
      `${API_ENDPOINTS.getHistory}?table=${"list"}&ref=${parseInt(
        variantInit[`list_ref`]
      )}`,
      config
    )
    .then(function (response) {
      setListHistory(response?.data);
      const list = response?.data?.findLast((l) => l?.list_isCurrent === 1);

      setVariant(list);
      addButtonId(setVariant);
      setPageArr(Array.from(Array(list?.list_details?.pages), (e, i) => i + 1));
      setItem(list?.list_details?.buttons[0]);
      setIndex(response?.data?.findIndex((i) => i?.list_isCurrent === 1));
    })
    .catch(function (error) {
      console.log("res", error);
    });
};

export const handleRevertChanges = (
  type,
  newValue,
  data,
  contextName,
  variant,
  handleListSelect2,
  handleVariantSelect2,
  setList,
  setVariant,
  setPageArr,
  setPage,
  closeDialog,
  setNewChanges
) => {
  console.log(
    "type:",
    type,
    "nv:",
    newValue,
    "data:",
    data,
    "cn:",
    contextName,
    "v:",
    variant
  );
  const originalList = structuredClone(
    data[contextName].filter(
      (original) =>
        JSON.parse(original?.uid) === JSON.parse(variant?.uid) &&
        original.list_isDeleted === 0
    )[0]
  );

  if (type === "list change") {
    handleListSelect2("list change", newValue);
  } else if (type === "variant change") {
    handleVariantSelect2("variant change", newValue);
  } else {
    setList(originalList);
    setVariant(
      data[contextName].find(
        (screen) =>
          JSON.parse(screen.uid) === JSON.parse(originalList.uid) &&
          screen.list_isDeleted === 0
      )
    );
    setPageArr(
      Array.from(Array(originalList?.list_details?.pages), (e, i) => i + 1)
    );
    setPage(1);
  }
  closeDialog();
  setNewChanges(false);
};
